// import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class JumpToService {}
